import { IResponseDto } from '@r1-frontend/api-domru/core-profile/v1/suspension/get/dto/responseDto';

export const enum EServiceType {
    main = 'main',
    included = 'included',
    additional = 'additional',
}

export const enum EStages {
    init = 'init',
    activate = 'activate',
    datePicker = 'datePicker',
    costInfo = 'costInfo',
    result = 'result',
}

export interface IBaseService {
    id: number,
    type: EServiceType,
    title: string,
    productId: number,
    isChecked: boolean,
    description: string,
    innerServices: string[],
    suspendCost: number,
    isSuspended: boolean,
    suspendedDateFrom: string,
    suspendedDateTo: string,
    sortIdx: number,
}

export type THowItWorks = IResponseDto['howItWorks']

export interface IState {
    isLoading: boolean,
    errorMessage: string,
    successResult: boolean,

    currentStage: EStages,
    showSuspended: boolean,
    showHowItWorks: boolean,
    changeDatesFlow: boolean,

    services: Record<number, IBaseService>,
    howItWorks?: THowItWorks,

    suspendFrom: string,
    suspendTo: string,

    suspendPrice: number,
    recommendPay: number,
    remainingPay: number,
    balanceAfterSuspend: number,
    daysToUnsuspendTv: number,
}
